var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5003 8L24.5003 21C24.5003 21.1326 24.4476 21.2598 24.3538 21.3536C24.2601 21.4473 24.1329 21.5 24.0003 21.5C23.8677 21.5 23.7405 21.4473 23.6467 21.3536C23.553 21.2598 23.5003 21.1326 23.5003 21L23.5003 9.2075L8.35403 24.3538C8.26021 24.4476 8.13296 24.5003 8.00028 24.5003C7.8676 24.5003 7.74035 24.4476 7.64653 24.3538C7.55271 24.2599 7.5 24.1327 7.5 24C7.5 23.8673 7.55271 23.7401 7.64653 23.6462L22.7928 8.5L11.0003 8.5C10.8677 8.5 10.7405 8.44732 10.6467 8.35355C10.553 8.25979 10.5003 8.13261 10.5003 8C10.5003 7.86739 10.553 7.74021 10.6467 7.64645C10.7405 7.55268 10.8677 7.5 11.0003 7.5L24.0003 7.5C24.1329 7.5 24.2601 7.55268 24.3538 7.64645C24.4476 7.74021 24.5003 7.86739 24.5003 8Z",
    fill: "#F0EAD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/ArrowUpRight.d295aaada61062316f22e862da536d6f.svg";
export { ForwardRef as ReactComponent };